<div class="modal fade" id="dialogCompra" tabindex="-1" role="dialog" aria-labelledby="compra" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title" id="title">Itens de compra</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="table-responsive" style="min-height: 500px;">
          <table class="table table-eddy" style="font-size: 12px;">
            <thead>
              <tr>
                <th scope="col">Quantidade</th>
                <th scope="col">Unidade</th>
                <th scope="col">Descrição</th>
                <th scope="col" class="text-right">Vl. Unitário</th>
                <th scope="col" class="text-right">Valor Total</th>
                <th scope="col" class="text-right">Desconto</th>
                <th scope="col" class="text-right">ICMS/IPI</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of listaItens; let idx = index">
                <td class="text-right" style="width: 80px">
                  {{item.quantidade | number:'1.3-3'}}</td>
                <td style="width: 80px; font-weight: bold; text-align: center;">
                  {{item.produto_unidade.unidade.nome}}</td>
                <td style="width: 40%">{{item.produto_unidade.produto.codigo}}
                  {{item.produto_unidade.produto.nome}}</td>
                <td class="text-right" style="width: 180px">
                  {{item.valor_unitario | number:'1.3-3'}}</td>
                <td class="text-right" style="width: 180px">
                  {{item.valor_total | number:'1.2-2'}}</td>
                <td class="text-right" style="width: 100px">
                  {{item.valor_desconto | number:'1.2-2'}}</td>
                <td class="text-right" style="width: 100px">
                  {{item.valor_icmsipi | number:'1.2-2'}}</td>

              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-link" id="btnCancelar" data-dismiss="modal">Cancelar</button>
      </div>
    </div>
  </div>
</div>